import React from 'react'

import { Button, List } from 'ui'
import BaseModal from 'components/Modals/BaseModal'
import { useGetUrl } from 'components/Hooks'

import { t } from 'translations'

function AttachmentsModal({ files, attachmentType }) {
  const { getUrlHandler } = useGetUrl({ attachmentType })
  return (
    <BaseModal title="components.attachments.ATTACHMENTS_MODAL">
      <List>
        <List.Header>{t('forms.fileUpload.ATTACHMENTS')}</List.Header>
        {!files?.length && (
          <List.Item className="list-group-item col-12 d-flex flex-row">
            <i>{t('components.attachments.NO_ATTACHMENTS')}</i>
          </List.Item>
        )}
        {files?.map(file => {
          if (!file) return null
          return (
            <List.Item className="list-group-item col-12 d-flex flex-row justify-content-between" key={file.key}>
              <Button
                type="button"
                isLink
                onClick={async () => {
                  const url = await getUrlHandler({ key: file.key })
                  if (url) window.open(url, '_blank')
                }}
              >
                <div className="m-2 d-flex flex-row align-items-center">
                  <div>
                    <div className="fa-regular fa-file" />
                  </div>
                  <div className="ml-2 text-break">{file.name}</div>
                </div>
              </Button>
            </List.Item>
          )
        })}
      </List>
    </BaseModal>
  )
}

export default AttachmentsModal
